/* template */
<template><div class="result-wrap"><div class="result-container"><div class="reward-content"><div v-for="(item, index) in (rewardArr)" :key="item.index" class="reward-item"><span class="unit-title">{{item.couponType}}</span><div class="number-place"><div :class="(item.className)">{{ item.coupon.max_benefit_capacity.value}}</div><span class="unit">{{item.coupon.max_benefit_capacity.unit}}</span></div><div class="text-place"><div class="coupon-name">{{ item.coupon.name }}</div><div class="coupon-text">{{ item.coupon.usage_limit }}</div><div class="coupon-text">{{ item.coupon.valid_period }}</div></div><mpx-image :src="(btnImg)" @tap="useCoupon(item)" class="to-use"/></div><mpx-image src="https://ut-static.udache.com/webx/ut/xQR3npBG48DFj7_StfOoJ.png" class="bottom-wrap"/><mpx-image src="https://ut-static.udache.com/webx/ut/6tqAisl_LKoQZQzD5S8jI.png" class="bottom-click" v-if="(rewardArr.length > 2)"/></div></div><mpx-image :src="(bannerInfo.image)" mode="widthFix" @tap="jumpLink" class="result-banner" v-if="(bannerInfo.image)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4acfffba"}'>
@font-face {
  font-family: UniSansHeavyItalic-self
  src: url('https://ut-static.udache.com/webx/ut/vmQnYmHW1SxSO7AHH9iWh_UniSansHeavyItalic.ttf')
}
@font-face {
  font-family: HPMQPQVGfwE9Z-self
  src: url('https://ut-static.udache.com/webx/ut/vvhEWgy-HPMQPQVGfwE9Z.ttf')
}
.result-wrap
  display: flex
  flex-direction: column
  align-items: center
  width: 750rpx
  min-height: 100vh
  padding-top 126rpx
  background: url('https://ut-static.udache.com/webx/ut/I-bRmy-67EHV94KZTLj6G.png')
  background-repeat: no-repeat
  background-size: 100vw auto
  background-color: RGB(255, 102, 0)
  box-sizing border-box
.result-container
  position: relative
  display flex
  justify-content: center
  width: 710rpx
  height: 840rpx
  background: url('https://ut-static.udache.com/webx/ut/Igudypg2CGMyCRq3nCqd4.png') center no-repeat
  background-size: 100% 100%
.reward-content
  width: 686rpx
  height: 651.71rpx
  margin-top: 112.29rpx
  overflow: scroll
.reward-item:first-child
  margin-top: 30.71rpx
.reward-item
  position: relative
  display: flex
  justify-content: flex-start
  align-items: center
  width: 670rpx
  height: 207rpx
  background: url('https://ut-static.udache.com/webx/ut/Z3vOO0mh_oS2jV91TyZ2w.png') center no-repeat
  background-size: 100% 100%
.unit-title
  position: absolute
  top: 8.47rpx
  left: 37rpx
  color: #FFFFFF
  font-size: 24rpx
  font-family: HPMQPQVGfwE9Z-self
  letter-spacing: 4rpx
.number-place
  position: relative
  display: flex
  justify-content: space-around
  align-items: center
  width: 148rpx
  height: 144rpx
  margin-left: 34rpx
  margin-right: 33.88rpx
  margin-top: -16.93rpx;
.digit-1, .digit-2, .digit-3
  color: #F86500
  font-weight: 900
  font-family: UniSansHeavyItalic-self
.digit-1
  font-size: 100rpx
.digit-2
  font-size: 80rpx
.digit-3
  font-size: 58rpx
.unit
  position: absolute
  right: -8rpx
  bottom: 52rpx
  font-size: 28rpx
  color: RGB(255, 102, 0)
.text-place
  margin-top: 86rpx;
  width: 225rpx
  height: 100%
.coupon-name
  color: #4D4C4C
  line-height: 24rpx
  font-weight: 500
  font-family: PingFangSC-Medium
  font-size: 24rpx
  letter-spacing: 0
  margin-bottom: 18rpx
.coupon-text
  color: #878787
  font-size: 18rpx
  line-height: 1
  font-family: PingFangSC-Regular
  letter-spacing: 0
  margin-bottom: 10rpx
.to-use
  position: absolute
  right: 35rpx
  top: 61rpx
  width: 162rpx
  height: 60rpx
.bottom-wrap
  position: absolute
  bottom: 0
  left: 0
  width: 710rpx
  height: 180rpx
.bottom-click
  position:absolute
  left: 336rpx
  bottom: 48rpx
  width: 38rpx
  height: 38rpx
.result-banner
  width: 710rpx
  margin-top: 40rpx
  margin-bottom: 102rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4acfffba"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./result-page.mpx.js?isComponent&outputPath=components%2Fresult-page4acfffba%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./result-page.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fresult-page4acfffba%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4acfffba"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/result-page4acfffba/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
